<template>
	<v-container class="pa-2 pa-sm-3" max-width="1100">
		<div class="d-flex align-center mb-3">
			<SideSelector />
			<v-spacer />
		</div>
		<ScheduleEditor :side="selectedSide" />
	</v-container>
</template>

<script setup>
import { onMounted } from "vue";
import schedulesStore from "../stores/schedulesStore.js";
import ScheduleEditor from "../components/ScheduleEditor.vue";
import SideSelector from "../components/SideSelector.vue";
import { useSelectedSide } from "../composables/useSelectedSide.js";

var selectedSide = useSelectedSide();

onMounted(() => schedulesStore.methods.load());
</script>
